import { Modal } from '@/ui/Modal'
import styles from './SwitchUserModal.module.scss'
import { SwitchUserForm } from './SwitchUserForm'
import { useModal } from '@/components/Modal'

export const SwitchUserModal = () => {
    const { closeModal } = useModal()

    return (
        <Modal className={styles.modal} onClose={closeModal}>
            <SwitchUserForm />
        </Modal>
    )
}
